import { t } from 'ttag';
import classNames from 'classnames';

import { Button } from '@ui/Button';
import { SavedSearchSubscribeldContainer } from '@containers/SavedSearchSubscribeld';
import TelegramIcon from '@svg/telegram-light.svg';

// styles
import s from './SavedSearchSubscribeldBottom.sss';

type SavedSearchSubscribeldBottomType = {
  className?: string,
  onTelegramClick(): void;
};

export const SavedSearchSubscribeldBottom: React.FC<SavedSearchSubscribeldBottomType> = ({
  className,
  onTelegramClick,
}) => (
  <div className={classNames(s.root, className)}>
    <div className={s.title}>
      <div className={s.textWrapper}>
        <p className={s.titleText}>
          {t`Не знайшли те, що шукаєте?`}
        </p>
        <p className={s.description}>
          {t`Підпишіться на пошук, щоб дізнаватися про появу нових речей`}
        </p>
      </div>
    </div>
    <ul className={s.buttonsWrapper}>
      <li className={s.buttonWrapper}>
        <SavedSearchSubscribeldContainer />
      </li>
      <li className={s.buttonWrapper}>
        <Button
          theme="secondary"
          onClick={() => {
            onTelegramClick();
          }}
          className={s.button}
        >
          <TelegramIcon className={s.telegramIcon} />
          В Telegram
        </Button>
      </li>
    </ul>
  </div>
);

export default SavedSearchSubscribeldBottom;
